//Set enumeration for themes
export enum Theme{
    VIRTUALLAUNDRY = 'virtuallaundry',
    NEWASCO = 'newasco',
    WASMIJNWAS = 'wasmijnwas',
  }
  
  //Set configuration for each app
  const themeConfig = {
    [Theme.VIRTUALLAUNDRY]: {
      appId: 'com.it2.virtuallaundry',
      appName: 'VL App'
    },
    [Theme.NEWASCO]: {
      appId: 'com.it2.newasco',
      appName: 'Newasco App',
      appLanguage: 'nl-NL',
      webportalUrl: 'https://newasco.virtuallaundry.net/service.asmx',
      apiUrls: ['https://vlapivl3.virtuallaundry.net/', 'https://vlapivl7.virtuallaundry.net/', 'https://vlapivl45.virtuallaundry.net/']
    },
    [Theme.WASMIJNWAS]: {
      appId: 'com.it2.wasmijnwas',
      appName: 'Wasmijnwas',
      appLanguage: 'nl-NL',
      webportalUrl: 'https://wasmijnwas.virtuallaundry.net/service.asmx',
      apiUrls: ['https://vlapivl51.virtuallaundry.net/']
    }
  };
  
  //Change this to set the app that should be build
  export const currentTheme: Theme = Theme.WASMIJNWAS;

  //Set themeConfig according to currentTheme 
  export const { appId, appName, webportalUrl, appLanguage, apiUrls } = themeConfig[currentTheme] as any;
